
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"24","height":"2","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"stroke":"#000","stroke-width":"2","d":"M24 1H0"}})])
      }
    
      }
    